import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, OPTIONAL, REQUIRED } from "./utils";
import { confirmTaxIdFieldConfig, taxIdFieldConfig } from "./_common";
import * as POLAND from "pages/employer-of-record/onboarding/profile-info/form/pl/constants.pl";

export const polandFields = {
  plMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "plMaritalStatus",
    label: "Marital Status",
    validations: REQUIRED,
    placeholder: "Select Marital Status",
    options: POLAND.MARITAL_STATUS_OPTIONS,
    scenarios: {
      onboarding: countryIs("PL"),
    },
    value: () => "", // TODO: expose plMaritalStatus in ProfileInfo query
  }),
  plSex: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "plSex",
    label: "Sex",
    placeholder: "Select Sex",
    message:
      "For the time being, we are limited to these two options. We recognize that life is more nuanced and are actively exploring ways to fully reflect everyone's experiences.",
    options: POLAND.SEX_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("PL"),
    },
    value: () => "", // TODO: expose plSex in ProfileInfo query
  }),
  plRequiresWorkPermit: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "plRequiresWorkPermit",
    label: "Requires Work Permit",
    placeholder: "Select Work Permit Status",
    options: POLAND.WORK_PERMIT_OPTIONS,
    validations: REQUIRED,
    hideWhen: {
      nationality: (value) => typeof value === "string" && value === "PL",
    },
    scenarios: {
      onboarding: countryIs("PL"),
    },
    value: () => "", // TODO: expose plRequiresWorkPermit in ProfileInfo query
  }),
  plPesel: {
    ...taxIdFieldConfig("PL", "plPesel"),
    validations: {
      ...taxIdFieldConfig("PL", "plPesel").validations,
      ...OPTIONAL,
    },
  },
  plConfirmPesel: {
    ...confirmTaxIdFieldConfig("PL", "plPesel"),
    validations: {
      ...confirmTaxIdFieldConfig("PL", "plPesel").validations,
      ...OPTIONAL,
    },
  },
};
